import type { PublishVoiceCallSignalInput } from '../../../types/voice-call'
import {
  buildTransferSignalPayload,
  type TransferSignalAction,
  type TransferSignalPayload,
} from '@shared/calls/transfer'

export function publishTransferInput(
  base: Pick<PublishVoiceCallSignalInput, 'callId' | 'callerId' | 'calleeId' | 'conversationId'>,
  action: TransferSignalAction,
  fields: Omit<TransferSignalPayload, 'action'>,
): PublishVoiceCallSignalInput {
  return {
    ...base,
    type: 'TRANSFER',
    payload: buildTransferSignalPayload(action, fields),
  }
}
